// src/ImageComponent.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Scene from './Scene';
import AnimationComponent from './AnimationComponent'
import PFPComponet from './PFPComponet';


const ImageComponent = () => {
    const [imageData, setImageData] = useState(null);
    const [plateColor, setPlateColor] = useState('')
    const [backgroundImage, setBackgroundImage] = useState('')
    const { number } = useParams();

    const [toggleTwoD, setToggleTwoD] = useState(false)
    const [toggleVoxel, setToggleVoxel] = useState(false)
    const [togglePFP, setTogglePFP] = useState(true)
    // ?view=vx or ?view=2d opens that view directly (0 = PFP, 1 = voxel 3D, 2 = 2D sprites)
    const initialView = { vx: 1, '2d': 2 }[new URLSearchParams(window.location.search).get('view')] ?? 0
    const [displaySelector, setDisplaySelector] = useState(initialView)
    const [isMounted, setIsMounted] = useState(false)

    
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          // same-origin API (api/metadata): revealed metadata or the "Wen reveal?!" placeholder
          const response = await fetch(`/api/metadata/${number}`);
          if (!response.ok) throw new Error(`metadata ${number}: HTTP ${response.status}`);
          const data = await response.json();
          const trait = name => data?.attributes?.find(a => a.trait_type === name)?.value
          setImageData(data);
          setPlateColor(trait('Case'))
          setBackgroundImage(trait('Background'))
        } catch (error) {
          console.error('Error fetching JSON data:', error);
        }
      };
      if (number) fetchData();
    }, [number]);

    // console.log(number)

    const toggleDisplay = () => {
      setToggleVoxel(!toggleVoxel);
    };

    useEffect(() => {
      if (displaySelector === 0) {
        setToggleVoxel(false)
        setToggleTwoD(false)
        setTogglePFP(true)
      } else if (displaySelector === 1) {
        setToggleTwoD(false)
        setTogglePFP(false)
        setToggleVoxel(true)
      } else if (displaySelector === 2) {
        setToggleVoxel(false)
        setTogglePFP(false)
        setToggleTwoD(true)
      }
    }, [displaySelector])

    useEffect(() => {
      setIsMounted(true)
    }, [])
    
    
    return (
      <div>
        {imageData && isMounted && (
          <>
            {toggleTwoD && <AnimationComponent number={number} setDisplaySelector={setDisplaySelector} backgroundImage={backgroundImage}/>}
            {toggleVoxel && <Scene number={number} plateColor={plateColor} imageData={imageData} setDisplaySelector={setDisplaySelector}/>}
            {togglePFP && <PFPComponet image={imageData.image} number={number} toggleDisplay={toggleDisplay} setDisplaySelector={setDisplaySelector} />}
          </>
        )}
      </div>
    );
  };
  
  export default ImageComponent;

